import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Col, Card, Row, Divider } from 'antd';
import { TextRegular12, TextRegular14 } from 'styles/typography';

import CompanyCultureFieldsList from '../CompanyCultureFieldsList/CompanyCultureFieldsList';
import { selectCultureFieldsGroupedByCompanies } from 'app/containers/Map/slice/selectors';
import { toFixedIfFloat } from 'utils/helpers';

interface IProps {}

const CompaniesList: FC<IProps> = props => {
  const { t } = useTranslation();

  const cultureCompaniesFieldsData = useSelector(
    selectCultureFieldsGroupedByCompanies,
  );

  return (
    <>
      {cultureCompaniesFieldsData.map(cultureCompanyItem => {
        if (!cultureCompanyItem.area) {
          return null;
        }

        return (
          <React.Fragment key={cultureCompanyItem.company.id}>
            <Card
              bordered={false}
              title={cultureCompanyItem.company.name}
              style={{ marginTop: '12px' }}
            >
              <Row>
                <Col span={12}>
                  <TextRegular14>
                    {t(
                      'Cultures.Details.DetailsCard.CulturalArea',
                      'Cultural area',
                    )}
                  </TextRegular14>
                </Col>

                <Col span={12}>
                  <TextRegular12>
                    {toFixedIfFloat(cultureCompanyItem.area)} Ha
                  </TextRegular12>
                </Col>
              </Row>
              <Divider dashed />

              <Row>
                <Col span={12}>
                  <TextRegular14>
                    {t(
                      'Cultures.Details.DetailsCard.HarvestPlan',
                      'Harvest plan',
                    )}
                  </TextRegular14>
                </Col>

                <Col span={12}>
                  <TextRegular12>
                    {`${cultureCompanyItem.harvest} t/Ha`}
                  </TextRegular12>
                </Col>
              </Row>
            </Card>
            <CompanyCultureFieldsList
              mappedFieldParams={cultureCompanyItem.mappedFields.map(
                field => field.fieldParameters,
              )}
            />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CompaniesList;
